import React from "react";

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import { useDispatch, useSelector } from "react-redux";

function OverallSearch() {
  const dispatch = useDispatch();
  const searchString = useSelector((state) => state.searchString);

  const handleClick = () => {
    dispatch({
      type: "SET_ADVANCED_SEARCH_ON",
      payload: true,
    });
    dispatch({
      type: "UPDATE_FILTERED_DATA",
    });
  };

  const handleChange = (e) => {
    dispatch({
      type: "HANDLE_SEARCH_BOX_CHANGE",
      payload: e.target.value,
    });
    dispatch({
      type: "UPDATE_FILTERED_IDS_BASED_ON_SEARCH_BOX",
    });
    dispatch({
      type: "UPDATE_FILTERED_DATA",
    });
    dispatch({
      type: "SET_PAGE_NUMBER",
      payload: 1,
    });
  };

  return (
    <Stack spacing={1}>
      <Typography variant="h5" gutterBottom component="div">
        Overall Search
      </Typography>
      <TextField
        id="outlined-basic"
        label="Search..."
        variant="outlined"
        value={searchString}
        onChange={(e) => {
          handleChange(e);
        }}
      />
      <Button variant="text" onClick={handleClick}>
        Advanced Search
      </Button>
    </Stack>
  );
}

export default OverallSearch;
